export default "__VITE_ASSET__CkXwC1fw__"